module.exports = __webpack_public_path__ + "img/merchsource-logo.99c716b2.png";